/**
 * Attribution for blog cover photos sourced from Unsplash. Keyed by post slug.
 * Unsplash's license allows free commercial use; we credit the photographer per
 * their guidelines. Case-study covers (our own screenshots) have no entry.
 *
 * Generated alongside the images by scripts/source-cover.mjs (credits.json).
 */
export interface CoverCredit {
  photographer: string
  photographerUrl: string
  photoUrl: string
}

export const COVER_CREDITS: Record<string, CoverCredit> = {
  'choir-online-donations': {
    photographer: 'David Beale',
    photographerUrl: 'https://unsplash.com/@davidbeale',
    photoUrl: 'https://unsplash.com/photos/photo-of-music-score-gOsGgt4olNs',
  },
  'best-website-platforms-for-music-festivals': {
    photographer: 'Hanny Naibaho',
    photographerUrl: 'https://unsplash.com/@hannynaibaho',
    photoUrl: 'https://unsplash.com/photos/group-of-people-raising-there-hands-in-concert-aWXVxy8BSzc',
  },
  'why-classical-festivals-overpay-for-submission-software': {
    photographer: 'Larisa Birta',
    photographerUrl: 'https://unsplash.com/@larisabirta',
    photoUrl: 'https://unsplash.com/photos/people-playing-violin-inside-dim-room-slbOcNlWNHA',
  },
  'why-your-orchestra-needs-a-modern-website': {
    photographer: 'Samuel Sianipar',
    photographerUrl: 'https://unsplash.com/@samthewam24',
    photoUrl: 'https://unsplash.com/photos/group-of-person-playing-violin-4TNd3hsW3PM',
  },
  'application-subdomain-cost-festivals': {
    photographer: 'Krists Luhaers',
    photographerUrl: 'https://unsplash.com/@kristsll',
    photoUrl: 'https://unsplash.com/photos/a-woman-raising-her-arms-in-the-air-in-front-of-tents-DSB1MZWsGco',
  },
  'festivals-losing-applicants': {
    photographer: 'Nadin Mario',
    photographerUrl: 'https://unsplash.com/@nadinmario',
    photoUrl: 'https://unsplash.com/photos/woman-playing-violin-in-grayscale-al2FHdZKxpU',
  },
}

/** Canonical cover path for a post slug. */
export function coverSrc(slug: string): string {
  return `/images/blog/covers/${slug}.webp`
}
